$('.product_carousel').slick({
  infinite: false,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        arrows: false
      }
    }
  ]
})
$('.testim_slider').slick({
  infinite: false,
  slidesToShow: 1,
  dots: true,
  arrows: false,
  speed: 500,
  fade: true,
  cssEase: 'linear'
})

$('.col_slider').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true,
        variableWidth: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false
      }
    }
  ]
})

$('.show_filter a').on('click', function(e){
  e.preventDefault();
  $('.blog_nav ul').slideToggle()
})

$('.site-footer p.title').on('click', function(){
  $(this).closest('.site-footer__item-inner--link_list').toggleClass('open')
})

$('.single_faq h4').on('click', function(e){
  e.preventDefault();
  if ($(this).closest('.single_faq').hasClass('active')) {
    $('.single_faq').removeClass('active');
    return false;
  }
  $('.single_faq').removeClass('active');
  $(this).closest('.single_faq').addClass('active');
})

$(document).on('click', '.prd-Card_Family .prd-Variants_Options div.prd-Variants_Option', function(){
  if (!$(this).hasClass('prd-Variants_Option-active')) {
    $(this).closest('.prd-Variants_Options').find('.prd-Variants_Option-active').removeClass('prd-Variants_Option-active')
    $(this).addClass('prd-Variants_Option-active')
    $(this).closest('.prd-Card').find('.prd-Card_Loading').css({
      'opacity': 1
    })
    var image = $(this).attr('featured')
    var hover = $(this).attr('hover')
    var url = $(this).attr('href')
    $(this).closest('.prd-Card').find('.prd-Card_Image-featured').find('img').attr('srcset', image)
    $(this).closest('.prd-Card').find('.prd-Card_Image-hover').find('img').attr('srcset', hover)
    $(this).closest('.prd-Card').find('.prd-Card_Url').attr('href', url)
  }
  $(this).closest('.prd-Card').find('.prd-Card_Loading').css({
    'opacity': 0
  })
  return false;
})

if ($(window).width()>1023) {
  if ($('.slides').length > 0) {
    var mySlider = slider('.slides');
  }
}




$(window).load(function(){
  $('#shopify-section-collection-page, #shopify-section-collection-page2, #shopify-section-collection-page3').css({
    'width': $(window).width(),
    'height': $(window).height()
  })
})

$(window).resize(function(){
  $('#shopify-section-collection-page, #shopify-section-collection-page2, #shopify-section-collection-page3').css({
    'width': $(window).width(),
    'height': $(window).height()
  })
})


$('.top_header button').on('click', function(e){
  e.preventDefault()
  $('.side_menu').addClass('show')
})


$('.side_menu svg').on('click', function(e){
  e.preventDefault()
  $('.side_menu').removeClass('show')
})

function buildSKUFamily() {
  if ($('#Collection .grid__item').length > 0) {
    let pageUrl = "https://" + window.location.host + "/pages/products-json";

    $.get(pageUrl, function( data ) {
      let all_pages = JSON.parse(data)

      $('#Collection .grid__item').each(function(){
        var currProdSKU = $(this).find('.prd-Card_Family').attr('data-product-sku');
        var currSize = $(this).find('.prd-Card_Family').attr('data-product-size');

        var sizes = '';

        currProdSKU = currProdSKU.split('.')
        var currProdFamSKU = currProdSKU[0] + '.' + currProdSKU[1];

        if ($(this).find('.prd-Variants_Options').html() == '') {

          for (var i = 0; i < all_pages.length; i++) {
            let prodSKU = all_pages[i].variants[0].sku;
            prodSKU = prodSKU.split('.')
            var prodFamSKU = prodSKU[0] + '.' + prodSKU[1];

            if (currProdFamSKU == prodFamSKU) {
              for (var a = 0; a < all_pages[i].tags.length; a++) {
                if (all_pages[i].tags[a].includes('size--')) {
                  var wanted_tag = all_pages[i].tags[a].replace('size--', '').replace('mm', '');
                  var class_l = '';
                  if (wanted_tag == currSize) {
                    var class_l = 'prd-Variants_Option-active';
                  }
                  if (all_pages[i].media.length > 1) {
                    var hover_img = all_pages[i].media[1].src
                  } else {
                    var hover_img = '';
                  }
                  sizes = '<div href="/products/'+all_pages[i].handle+'" class="prd-Variants_Option '+ class_l +' size-'+wanted_tag+'" featured="'+all_pages[i].featured_image+'" hover-img="'+hover_img+'">'+wanted_tag+'<span class="prd-Variants_OptionMM">mm</span></div>';

                }
              }
            }
            if ($(this).find('.size-'+wanted_tag).length < 1) {
              $(this).find('.prd-Variants_Options').append(sizes);
            }

          }


        }

      });

    })
  }

}

// Shortcircuit variable
let triggered = false;

function ScrollExecute() {
  // Locate loadmore button
  let moreButon = $('#more').last();

  // Get URL from the loadmore button
  let nextUrl = $(moreButon).find('a').attr("href");

  // Button position when AJAX call should be made one time
  if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {
    // Trigger shortcircuit to ensure AJAX only fires once
    triggered = true;

    // Make ajax call to next page for load more data
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
        moreButon.remove();
      }
    })
    .done(function(data) {
      // Append data
      $('#Collection .row').append($(data).find('#Collection').find('.row').html());
      buildSKUFamily();

      // On success, reset shortcircuit
      triggered = false
    });
  }
}

function ScrollExecute_blog() {
  // Locate loadmore button
  let moreButon = $('#more_blog').last();

  // Get URL from the loadmore button
  let nextUrl = $(moreButon).find('a').attr("href");

  // Button position when AJAX call should be made one time
  if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {

    // Trigger shortcircuit to ensure AJAX only fires once
    triggered = true;

    // Make ajax call to next page for load more data
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
        moreButon.remove();
      }
    })
    .done(function(data) {
      // Append data
      $('.blog_grid').append($(data).find('.blog_grid').html());

      // On success, reset shortcircuit
      triggered = false
    });
  }
}

$(document).on('click', '#more a', function(e){
    e.preventDefault();
    ScrollExecute();
  })

$(document).on('click', '#more_blog a', function(e){
    e.preventDefault();
    ScrollExecute();
  })

$(document).ready(function () {
  $('#more a').on('click', function(e){
    e.preventDefault();
    ScrollExecute();
  });
  $('#more_blog a').on('click', function(e){
    e.preventDefault();
    ScrollExecute_blog();
  });
  if ($('#Collection .grid__item').length > 0) {
    $('.filters-toolbar__product-count span').html($('#Collection .grid__item').length)
  }
  if ($('.blog_grid li').length > 0) {
    $('.filters-toolbar__product-count span').html($('.blog_grid li').length)
  }

  $('.finish_sel').change(function(){
    window.location = $(this).val()
  })
  $('.cart__quantity-td .cart__qty span').on('click', function(){
    if ($(this).hasClass('minus')) {
      val = $(this).closest('.cart__qty').find('input').val()
      val--;
      $(this).closest('.cart__qty').find('input').val(val).change()
    } else {
      val = $(this).closest('.cart__qty').find('input').val()
      val++;
      $(this).closest('.cart__qty').find('input').val(val).change()
    }
  })
  $('.desctop_images .image a').on('click', function(){
    $('.video_block').fadeIn();
  })
  $('.mobile_menu .tabs a').on('click', function(e){
    if (!$(this).hasClass('strongLink')) {
      e.preventDefault();
      var block = $(this).attr('href');
      $('.mobile_menu .tabs a').removeClass('active');
      $(this).addClass('active')
      $('.tabs_cont > div').hide().removeClass('active');
      $(block).fadeIn().addClass('active');
    }
  })
  $('.site-header__menu').click(function(){
    if ($(this).hasClass('mobile-nav--open')) {
      $(this).removeClass('mobile-nav--open')
      $(this).addClass('mobile-nav--close')
    } else {
      $(this).addClass('mobile-nav--open')
      $(this).removeClass('mobile-nav--close')
    }
    $('.mobile_menu').toggleClass('show');
  })

  $('.hide_menu').on('click', function(e){
    e.preventDefault();
    $('.site-header__menu').addClass('mobile-nav--open')
    $('.site-header__menu').removeClass('mobile-nav--close')
    $('.mobile_menu').toggleClass('show');
  })
  $('a.has_child').on('click', function(e){
    e.preventDefault();
    $(this).closest('.mobile_menu').addClass('viewSide')
    var menu = $(this).closest('li').find('ul').html()
    var title = $(this).text()
    $('.side_data .name').html(title);
    $('.side_data .menu ul').html(menu);
  })

  $('.side_data .name').on('click', function(e){
    $(this).closest('.mobile_menu').removeClass('viewSide')
  })

//   $('.site-header__cart').on('click', function(e){
//       e.preventDefault();
//       $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
//       $('.pop_up_container').show();
//       return false;
//     })
  $('header .js-mobile-nav-toggle').on('click', function(e){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $('.bottom_nav .js-mobile-nav-toggle').toggleClass('mobile-nav--open')
    $('.bottom_nav .js-mobile-nav-toggle').toggleClass('mobile-nav--close')
  	return false;
  })
   $('.bottom_nav .js-mobile-nav-toggle').on('click', function(e){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $('header .js-mobile-nav-toggle').toggleClass('mobile-nav--open')
    $('header .js-mobile-nav-toggle').toggleClass('mobile-nav--close')
  	return false;
  })
    $(document).on('click', '.cart-popup__close', function(e){
      e.preventDefault();
      $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
      $('.pop_up_container').hide();
      return false;
    })
    $('.filter_collection >ul>li').on('click', function(){
      $(this).toggleClass('open')
    })
    $('.toggle_filter').on('click', function(e){
      e.preventDefault()
      $('.filter_collection .filters-toolbar__item-child').slideToggle();
    })
    $('.toggle_sort').on('click', function(e){
      e.preventDefault()
      $('.filter_collection ul').slideToggle();
    })
    $('.disclosure__toggle').on('click', function(){
      $('.disclosure-list').slideToggle()
    })
    $('#shopify-section-collection-page3 .text span').on('click', function(){
      $(this).closest('.text').toggleClass('open')
      if ($(this).closest('.text').hasClass('open')) {
        $(this).html('- HIDE')
      } else {
        $(this).html('+ SHOW MORE')
      }
    })
    $('.play_video').on('click', function(){
      $('.video_block').show()
    })
    $('.video_block .close').on('click', function(){
      $('.video_block').hide()
    })
    lightGallery(document.getElementById('lightgallery'), {
      selector: '.run',
      zoom: true
    });
});

$(document).ajaxStop(function(){
  if ($('#Collection .grid__item').length > 0) {
    $('.filters-toolbar__product-count span').html($('#Collection .grid__item').length)
  }
  if ($('.blog_grid li').length > 0) {
    $('.filters-toolbar__product-count span').html($('.blog_grid li').length)
  }
})

$('.product_details_blocks .detail_block h3').on('click', function(){
  $(this).closest('.detail_block').toggleClass('view');
})


